'use client'
import React from 'react'
import { useFeatureFlags } from './use-feature-flags'

type FeatureToggleProviderProps = {
  children: React.ReactNode
  globalFlags: string[]
}

type FeatureToggleHooks = {
  isEnabled: (featureName: string) => boolean
}

const FeatureToggleContext = React.createContext({
  enabledFeatures: new Set<string>()
})

const FeatureToggleProvider = ({ children, globalFlags }: FeatureToggleProviderProps) => {
  const localFeatureFlags = useFeatureFlags(globalFlags)

  return (
    <FeatureToggleContext.Provider value={{ enabledFeatures: localFeatureFlags }}>
      {children}
    </FeatureToggleContext.Provider>
  )
}

// this needs to be used within a component that is 'use client'
const useFeatureToggle = (): FeatureToggleHooks => {
  const { enabledFeatures } = React.useContext(FeatureToggleContext)

  const isEnabled = (featureName: string) => {
    return enabledFeatures.has(featureName)
  }

  return { isEnabled }
}

export { FeatureToggleProvider, useFeatureToggle }
